// A broad, India-flavoured list of common small-business types used ONLY as
// type-ahead hints on the signup "What's your business?" field. These are
// NOT a closed list — they surface only as the owner types and matches their
// words, and they can always type anything of their own. The goal is to help,
// never to exclude (a business not in this list still types freely).

export const BUSINESS_HINTS = [
  // Property & construction
  "Real estate agent", "Property dealer", "Builder / developer", "Interior designer",
  "Architecture studio", "Civil contractor", "Modular kitchen dealer", "Furniture shop",
  "Plywood dealer", "Hardware shop", "Tiles & sanitaryware dealer", "Paint shop",
  "Electrical goods dealer", "Plumbing & pipes dealer", "Iron & steel trader",
  "Cement & building material supplier", "Glass & aluminium works", "Borewell services",
  // Health & wellness
  "Clinic", "Dental clinic", "Skin & hair clinic", "Physiotherapy centre",
  "Diagnostic lab", "Eye care / optical", "Ayurvedic clinic", "Veterinary clinic",
  "Gym / fitness centre", "Yoga studio", "Salon & spa", "Beauty parlour",
  // Education
  "Tuition centre", "Coaching institute", "Play school / preschool", "Computer training",
  "Music / dance academy", "Driving school", "Spoken English classes", "Skill training centre",
  // Food
  "Restaurant", "Cafe", "Cloud kitchen", "Caterer", "Bakery", "Sweet shop",
  "Tiffin / meal service", "Food truck",
  // Retail & trade
  "Garment / clothing shop", "Footwear shop", "Jewellery shop", "Mobile & electronics shop",
  "Grocery / kirana store", "Stationery shop", "Gift shop", "Optical shop",
  "Wholesale trader", "Distributor / dealer",
  // Services
  "Coworking space", "Event management", "Wedding planner", "Photography studio",
  "Travel agency", "Tours & holidays", "Car / bike rental", "Logistics & transport",
  "Packers & movers", "Courier service", "Printing press", "Digital marketing agency",
  "Advertising agency", "Web / software development", "IT services", "SaaS product",
  "Chartered accountant", "Tax & GST consultant", "Legal services", "Insurance agency",
  "Loan / DSA agent", "Recruitment / placement agency", "Security services",
  "Housekeeping / facility services", "Pest control", "AC sales & service",
  "Electronics repair", "Mobile repair", "Solar panel dealer", "RO / water purifier dealer",
  // Manufacturing & B2B
  "Manufacturer", "Fabrication unit", "Packaging supplier", "Machinery dealer",
  "Auto spare parts dealer", "Tyre dealer", "Agro / seeds & fertiliser dealer",
  // Auto
  "Car dealership", "Two-wheeler showroom", "Car service centre", "Used car dealer",
];
